// extracted by mini-css-extract-plugin
export var modal = "_cw-0";